import React, { useState, useEffect, useRef } from 'react';
import { DateTime } from 'luxon';

import CampaignList from './CampaignList';
import CreateCampaignModal from './CreateCampaignModal';
import { createCampaign, getCampaigns } from '../../../apis/campaigns.api';
import { useAuth } from '../../../contexts/auth.context';
import { useNavigate } from 'react-router-dom';

const Campaigns = () => {
  const [campaigns, setCampaigns] = useState([]);
  const [showModal, setShowModal] = useState(false);

  const navigate = useNavigate();
  const { auth } = useAuth();
  const authToken = useRef(auth?.idToken);

  useEffect(() => {
    authToken.current = auth?.idToken;
  }, [auth?.idToken]);

  useEffect(() => {
    // Replace this with the API call to fetch the list of campaigns
    const fetchData = async () => {
      const response = await getCampaigns();
      setCampaigns(
        response.sort((a, b) => {
          // Compare status first
          if (a.status !== b.status) {
            return b.status - a.status;
          }
          // If status is the same, compare expireAt dates
          return DateTime.fromISO(b.expireAt) - DateTime.fromISO(a.expireAt);
        })
      );
    };

    fetchData();
  }, []);

  const handleCreateCampaign = async campaign => {
    // Replace this with the API call to create a new campaign
    const newCampaign = await createCampaign(campaign, authToken.current);

    if (newCampaign) {
      setCampaigns([newCampaign, ...campaigns]);
      navigate(`/campaigns/${newCampaign.id}`);
    }
  };

  return (
    <div className="container">
      <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center border-bottom">
        <div>
          <div className="game-micro">campaign ledger</div>
          <h4 className="mb-0">Risk Free Plays</h4>
        </div>
        <div className="btn-toolbar mb-2 mb-md-0">
          <button type="button" className="btn btn-primary" onClick={() => setShowModal(true)}>
            Create Campaign
          </button>
          <button
            type="button"
            className="btn btn-secondary"
            onClick={() => navigate(`/campaigns/search`)}
          >
            <i className="fa-solid fa-search" /> Search
          </button>
        </div>
      </div>
      <CampaignList campaigns={campaigns} />
      <CreateCampaignModal
        show={showModal}
        onHide={() => setShowModal(false)}
        onCreate={handleCreateCampaign}
      />
    </div>
  );
};

export default Campaigns;
